define('viewModels/privileged/qm/InteractionsSearchTabsView',[
    'lib/knockout',
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'viewModels/NavMenu',
    'viewModels/privileged/qm/SearchResultsView',
    'viewModels/privileged/qm/SearchArchivedResultsView',

], function (ko,
             ViewModel,
             SwitchedView,
             NavMenu,
             SearchResultsView,
             SearchArchivedResultsView
    ) {
    'use strict';

    var InteractionsSearchTabsView = ViewModel.extend(function () {
        var self = this;

        self.navMenu = self.subView(NavMenu, [
            {
                hash: "#admin/interactions/search",
                label: "search.tabs.completedInteractionsTab"
            },
            {
                hash: "#admin/interactions/search/archived",
                label: "search.tabs.restoredInteractionsTab"
            }
        ]);

        self.subViews = self.subView(SwitchedView, {
            searchResultsView: SearchResultsView,
            archiveResultsView: SearchArchivedResultsView,
        });
    });
    return InteractionsSearchTabsView;
});
